import { saveEvent } from '../api';

/**
 * Function qui retourne un ensemble de callback utilisable par les popup
 * @param {*} globalLayer Le layer coteneur (ie. layergroup d'un événement)
 * @param {*} layer Le layer assosié à la popup
 * @param {*} types Liste des type d'overlays d'événement
 * @returns 
 */
export const editablePopupCallbacks = (globalLayer, layer, types = []) => ({
    onTypeChange: function (e) {
        const type = types.find(type => type.name === e.target.value);
        if (type.icon) {
            layer.setIcon(L.icon({
                iconUrl: `${type.icon}`,
                iconSize: [35,35]
            }));
        }
    },

    onSubmit: function (e) {
        e.preventDefault();
        const extraProperies = Object.fromEntries(new FormData(e.target).entries());
        
        const geojson = layer.toGeoJSON();
        geojson.properties = {...geojson.properties, ...extraProperies};

        layer.feature = geojson;
        saveEvent({...globalLayer._event, ...globalLayer.toGeoJSON()})
            .then((updatedEvent) => {
                M.toast({html: 'Elément sauvegardé', classes: 'green accent-4'});
                
                // Mettre à jour l'événement dans le layer global (eventDetails)
                if (typeof globalLayer.update === 'function') {
                    globalLayer.update(updatedEvent);
                } else {
                    globalLayer._event = updatedEvent;
                }
                
                // Mettre à jour l'événement dans la map
                if (globalLayer._map) {
                    globalLayer._map.event = updatedEvent;
                    
                    // Forcer le rafraîchissement des détails de l'événement dans la sidebar
                    if (typeof globalLayer._map._renderEventDetails === 'function') {
                        globalLayer._map._renderEventDetails();
                    }
                }
                
                layer.closePopup();
            });
    }
});